import { GridColDef } from '@mui/x-data-grid-premium';
import EnhancedDataGrid from 'components/enhanced/data-grid/EnhancedDataGrid';
import { filterOperators } from 'components/enhanced/data-grid/utils/filters';
import { TenantPage } from 'layouts';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IUnderStockQuantity } from '../types';
import { stockQuantityService } from '../api/stock-quantity.service';
import { baseCell } from 'components/cells';

export const StockUnderstockProducts = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.stock_quantity.understock';

  const [understock, setUnderstock] = useState<IUnderStockQuantity[]>([]);

  useEffect(() => {
    stockQuantityService.getUnderstockProducts(10, 0).then((res) => {
      setUnderstock(res.results);
    });
  }, []);

  const columns: GridColDef[] = [
    {
      field: 'product',
      valueGetter: (params) => params.row.product__code,
      headerName: t(`global.product`),
      width: 250,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'product__description',
      valueGetter: (params) => params.row.product__description,
      headerName: t(`global.description`),
      width: 300,
      filterOperators,
      renderCell: baseCell
    },
    {
      field: 'warehouse',
      headerName: t(`global.warehouse`),
      width: 250,
      filterOperators,
      valueGetter: (params) => params.row.warehouse__code,
      renderCell: baseCell
    },
    {
      field: 'total_quantity',
      headerName: t(`entities.stock_quantity.total_residual_quantity`),
      width: 150,
      type: 'number',
      filterable: false,
      sortable: false,
      valueGetter: (params) => params.row.total_quantity,
      renderCell: baseCell
    },
    {
      field: 'understock_threshold',
      headerName: t(`entities.stock_quantity.understock_threshold`),
      width: 150,
      type: 'number',
      filterable: false,
      sortable: false,
      valueGetter: (params) => params.row.understock_threshold,
      renderCell: baseCell
    },
    {
      field: 'total_quantity_ordered',
      headerName: t(`entities.stock_quantity.total_quantity_ordered`),
      width: 150,
      type: 'number',
      filterable: false,
      sortable: false,
      valueGetter: (params) => params.row.total_quantity_ordered ?? 0,
      renderCell: baseCell
    }
  ];

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={stockQuantityService}
        getMethod={stockQuantityService.getUnderstockProducts}
      />
    </TenantPage>
  );
};
